import { z } from 'zod';

import { BasePType } from './base';

export const SocialMediaIcon = z.object({
  tid: z.number(),
  name: z.string(),
  socialMediaIcon: z.string(),
});

export type SocialMediaIcon = z.infer<typeof SocialMediaIcon>;

export const SocialMediaIcons = BasePType.extend({
  type: z.enum(['socialMediaIcons']),
  flexAlignment: z.string().nullable(),
  socialMediaIcons: z.array(SocialMediaIcon),
});

export type SocialMediaIcons = z.infer<typeof SocialMediaIcons>;
